import { IAction } from "../../../models/Action";
import emptyState from "./emptyState";
import { actionTypes } from "./actions";
import { STATE_IDENTIFIER } from "./constants";
import { immutableSet } from "../../../utils/immutable";
import { compose } from "redux";
import { IDENTITY_SYSTEM } from "../../../module/constants";
import {
  TechnicalUserDisplayedModel,
  TechnicalUserModel,
} from "../../../models/TechnicalUsers";
import { IEntitlementItem } from "../../../models/Entitlements";
import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";

const {
  IS_EDITING,
  APPLICATIONS,
  STEP_ONE,
  STEP_ONE_LOADER,
  STEP_ONE_OUS,
  SELECTED_USER_TYPE,
  SELECTED_OU,
  SELECTED_OU_NAME,
  SELECTED_TU,
  STEP_TWO,
  STEP_TWO_ACCOUNTS,
  STEP_TWO_LOADER,
  STEP_THREE,
  STEP_THREE_CALL_STATE,
  STEP_THREE_PWD_POLICY,
  CREATION,
  TU_DESCRIPTION,
  TU_APPLICATION,
  TU_ENTITLEMENTS,
  TU_ENTITLEMENTS_LOADER,
  CATALOG_ENTITLEMENTS,
  CATALOG_ENTITLEMENTS_LOADER,
  ADDED_ENTITLEMENTS,
  DELETED_ENTITLEMENTS,
  CREATION_CALL_STATE,
  CALL_STATE,
  TU_ROBOT_APPLICATIONS,
  TU_ROBOT_USER_NUMBER,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.TECH_USER_GET_OU]: (state: any) => {
    return compose(
      immutableSet([STEP_ONE, STEP_ONE_LOADER], true),
      immutableSet([STEP_TWO, STEP_TWO_ACCOUNTS], [])
    )(state);
  },
  [actionTypes.TECH_USER_GET_OU_SUCCESS]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_ONE, STEP_ONE_LOADER], false),
      immutableSet([STEP_ONE, STEP_ONE_OUS], action.payload)
    )(state),
  [actionTypes.TECH_USER_GET_OU_FAILURE]: (state: any) =>
    compose(
      immutableSet([STEP_ONE, STEP_ONE_LOADER], false),
      immutableSet([STEP_ONE, STEP_ONE_OUS], [])
    )(state),

  [actionTypes.TECH_USER_GET_TU]: (state: any) =>
    immutableSet([STEP_TWO, STEP_TWO_LOADER], true, state),
  [actionTypes.TECH_USER_GET_TU_SUCCESS]: (state: any, action: any) => {
    const mappedResponse: TechnicalUserDisplayedModel[] = [];
    action.payload &&
      action.payload.length > 0 &&
      action.payload.forEach((tu: TechnicalUserModel) => {
        mappedResponse.push({
          _changePasswordAllowed: tu.changePasswordAllowed,
          _resetPasswordAllowed: tu.resetPasswordAllowed,
          applicationId: tu.applicationId,
          application: tu.applicationName,
          code: tu.tuCode,
          tiType: tu.tiType,
          description: tu.description,
          identitySystemId:
            IDENTITY_SYSTEM[
              tu.identitySystemId as keyof typeof IDENTITY_SYSTEM
            ],
          status: tu.status,
          tiCode: tu.tiCode,
          tuAccountId: tu.tuAccountId,
          _mfaRequired: tu.mfaRequired,
          _securityQuestionsRequired: tu.securityQuestionsRequired,
          _uigpOTPRequired: tu.uigpOTPRequired,
        });
      });
    return compose(
      immutableSet([STEP_TWO, STEP_TWO_ACCOUNTS], mappedResponse),
      immutableSet([STEP_TWO, STEP_TWO_LOADER], false)
    )(state);
  },
  [actionTypes.TECH_USER_GET_TU_FAILURE]: (state: any) => {
    return compose(
      immutableSet([STEP_TWO, STEP_TWO_ACCOUNTS], []),
      immutableSet([STEP_TWO, STEP_TWO_LOADER], false)
    )(state);
  },

  [actionTypes.TECH_USER_GET_APPLICATIONS_SUCCESS]: (state: any, action: any) =>
    immutableSet([APPLICATIONS], action.payload, state),
  [actionTypes.TECH_USER_GET_APPLICATIONS_FAILURE]: (state: any) =>
    immutableSet([APPLICATIONS], [], state),

  [actionTypes.TECH_USER_GET_TU_ENTITLEMENTS]: (state: any) => {
    return compose(
      immutableSet([CREATION, TU_ENTITLEMENTS], []),
      immutableSet([CREATION, TU_ENTITLEMENTS_LOADER], true)
    )(state);
  },
  [actionTypes.TECH_USER_GET_TU_ENTITLEMENTS_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: IEntitlementItem[] = [];

    let entList = [];
    entList =
      action.payload &&
      action.payload.length &&
      action.payload.filter((ent: any) => ent.showOnFrontend);

    if (entList && entList.length > 0) {
      for (let i = 0; i < entList.length; i++) {
        const currEnt: IEntitlementItem = entList[i];
        const temp = {
          ...currEnt,
          identitySystemId:
            IDENTITY_SYSTEM[
              currEnt.identity_system_id as keyof typeof IDENTITY_SYSTEM
            ],
          monoProfilo: currEnt.isMonoprofilo,
        };

        mappedResponse.push(temp);
      }
    }
    mappedResponse = action.payload.map((ent: IEntitlementItem) => {
      return {
        ...ent,
        identitySystemId:
          IDENTITY_SYSTEM[
            ent.identity_system_id as keyof typeof IDENTITY_SYSTEM
          ],
        monoProfilo: ent.isMonoprofilo,
      };
    });
    return compose(
      immutableSet([CREATION, TU_ENTITLEMENTS], mappedResponse),
      immutableSet([CREATION, TU_ENTITLEMENTS_LOADER], false)
    )(state);
  },
  [actionTypes.TECH_USER_GET_TU_ENTITLEMENTS_FAILURE]: (state: any) => {
    return compose(
      immutableSet([CREATION, TU_ENTITLEMENTS], []),
      immutableSet([CREATION, TU_ENTITLEMENTS_LOADER], false)
    )(state);
  },

  [actionTypes.TECH_USER_GET_CATALOG_ENTITLEMENTS]: (state: any) =>
    immutableSet([CREATION, CATALOG_ENTITLEMENTS_LOADER], true, state),
  [actionTypes.TECH_USER_GET_CATALOG_ENTITLEMENTS_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const mappedResponse = action.payload.map((entitlement: any) => {
      return {
        ...entitlement,
        identitySystemId:
          IDENTITY_SYSTEM[
            entitlement.identity_system_id as keyof typeof IDENTITY_SYSTEM
          ],
      };
    });
    return compose(
      immutableSet([CREATION, CATALOG_ENTITLEMENTS_LOADER], false),
      immutableSet([CREATION, CATALOG_ENTITLEMENTS], mappedResponse)
    )(state);
  },
  [actionTypes.TECH_USER_GET_CATALOG_ENTITLEMENTS_FAILURE]: (state: any) =>
    compose(
      immutableSet([CREATION, CATALOG_ENTITLEMENTS_LOADER], false),
      immutableSet([CREATION, CATALOG_ENTITLEMENTS], [])
    )(state),

  [actionTypes.TECH_USER_TYPE]: (state: any, action: any) =>
    immutableSet([SELECTED_USER_TYPE], action.payload, state),

  [actionTypes.TECH_USER_SELECT_OU]: (state: any, action: any) =>
    immutableSet([SELECTED_OU], action.payload, state),
  [actionTypes.TECH_USER_SELECT_OU_NAME]: (state: any, action: any) =>
    immutableSet([SELECTED_OU_NAME], action.payload, state),
  [actionTypes.TECH_USER_SELECT_TU]: (state: any, action: any) =>
    immutableSet([SELECTED_TU], action.payload, state),

  [actionTypes.TECH_USER_SET_APPLICATION_DETAIL]: (state: any, action: any) => {
    const {
      application,
      description,
      robotSelectedApplications,
      robotNumberUsers,
      selectedOu,
      selectedOuName,
    } = action.payload;

    return compose(
      immutableSet([CREATION, TU_APPLICATION], application),
      immutableSet([CREATION, TU_DESCRIPTION], description),
      immutableSet([CREATION, TU_ROBOT_USER_NUMBER], robotNumberUsers),
      immutableSet(
        [CREATION, TU_ROBOT_APPLICATIONS],
        robotSelectedApplications
      ),
      immutableSet([SELECTED_OU], selectedOu),
      immutableSet([SELECTED_OU_NAME], selectedOuName)
    )(state);
  },

  [actionTypes.TECH_USER_SET_EXISTING_ENTITLEMENTS]: (
    state: any,
    action: any
  ) => immutableSet([CREATION, TU_ENTITLEMENTS], action.payload, state),
  [actionTypes.TECH_USER_SET_ADDED_ENTITLEMENTS]: (state: any, action: any) =>
    immutableSet([CREATION, ADDED_ENTITLEMENTS], action.payload, state),
  [actionTypes.TECH_USER_SET_DELETED_ENTITLEMENTS]: (state: any, action: any) =>
    immutableSet([CREATION, DELETED_ENTITLEMENTS], action.payload, state),

  [actionTypes.TECH_USER_SET_IS_EDITING]: (state: any, action: any) =>
    immutableSet([IS_EDITING], action.payload, state),

  [actionTypes.TECH_USER_RESET_STATE]: (state: any) => {
    return compose(
      immutableSet([IS_EDITING], false),
      immutableSet([CREATION, TU_APPLICATION], null),
      immutableSet([CREATION, TU_DESCRIPTION], null),
      immutableSet([CREATION, TU_ENTITLEMENTS], []),
      immutableSet([CREATION, ADDED_ENTITLEMENTS], []),
      immutableSet([CREATION, DELETED_ENTITLEMENTS], [])
    )(state);
  },

  [actionTypes.TECH_USER_CREATE]: (state: any) =>
    immutableSet(
      [CREATION, CREATION_CALL_STATE],
      IResponseState.PENDING,
      state
    ),
  [actionTypes.TECH_USER_CREATE_SUCCESS]: (state: any) =>
    immutableSet(
      [CREATION, CREATION_CALL_STATE],
      IResponseState.SUCCESS,
      state
    ),
  [actionTypes.TECH_USER_CREATE_FAILURE]: (state: any) =>
    immutableSet([CREATION, CREATION_CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.TECH_USER_UPDATE]: (state: any) =>
    immutableSet(
      [CREATION, CREATION_CALL_STATE],
      IResponseState.PENDING,
      state
    ),
  [actionTypes.TECH_USER_UPDATE_SUCCESS]: (state: any) =>
    immutableSet(
      [CREATION, CREATION_CALL_STATE],
      IResponseState.SUCCESS,
      state
    ),
  [actionTypes.TECH_USER_UPDATE_FAILURE]: (state: any) =>
    immutableSet([CREATION, CREATION_CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.TECH_USER_DELETE]: (state: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.TECH_USER_DELETE_SUCCESS]: (state: any) =>
    immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.TECH_USER_DELETE_FAILURE]: (state: any) =>
    immutableSet([CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.TECH_USER_GET_PWD_POLICY_SUCCESS]: (state: any, action: any) =>
    immutableSet([STEP_THREE, STEP_THREE_PWD_POLICY], action.payload, state),
  [actionTypes.TECH_USER_GET_PWD_POLICY_FAILURE]: (state: any) =>
    immutableSet([STEP_THREE, STEP_THREE_PWD_POLICY], {}, state),

  [actionTypes.TECH_USER_BLOCK_ACCOUNT]: (state: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.TECH_USER_BLOCK_ACCOUNT_SUCCESS]: (state: any) =>
    immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.TECH_USER_BLOCK_ACCOUNT_FAILURE]: (state: any) =>
    immutableSet([CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.TECH_USER_UNLOCK_ACCOUNT]: (state: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.TECH_USER_UNLOCK_ACCOUNT_SUCCESS]: (state: any) =>
    immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.TECH_USER_UNLOCK_ACCOUNT_FAILURE]: (state: any) =>
    immutableSet([CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.TECH_USER_RESET_PWD]: (state: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.TECH_USER_RESET_PWD_SUCCESS]: (state: any) =>
    immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.TECH_USER_RESET_PWD_FAILURE]: (state: any) =>
    immutableSet([CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.TECH_USER_RESET_PWD_VERIFY_CA_MOBILE_OTP]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.TECH_USER_RESET_PWD_VERIFY_CA_MOBILE_OTP_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.TECH_USER_RESET_PWD_VERIFY_CA_MOBILE_OTP_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.TECH_USER_RESET_PWD_VERIFY_SEC_QUESTS]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.TECH_USER_RESET_PWD_VERIFY_SEC_QUESTS_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.TECH_USER_RESET_PWD_VERIFY_SEC_QUESTS_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.TECH_USER_RESET_PWD_VERIFY_UIGP_OTP]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.TECH_USER_RESET_PWD_VERIFY_UIGP_OTP_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.TECH_USER_RESET_PWD_VERIFY_UIGP_OTP_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.TECH_USER_CHANGE_PWD]: (state: any) =>
    immutableSet(
      [STEP_THREE, STEP_THREE_CALL_STATE],
      IResponseState.PENDING,
      state
    ),
  [actionTypes.TECH_USER_CHANGE_PWD_SUCCESS]: (state: any) =>
    immutableSet(
      [STEP_THREE, STEP_THREE_CALL_STATE],
      IResponseState.SUCCESS,
      state
    ),
  [actionTypes.TECH_USER_CHANGE_PWD_FAILURE]: (state: any) =>
    immutableSet(
      [STEP_THREE, STEP_THREE_CALL_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.TECH_USER_CHANGE_PWD_VERIFY_CA_MOBILE_OTP]: (state: any) =>
    immutableSet(
      [STEP_THREE, STEP_THREE_CALL_STATE],
      IResponseState.PENDING,
      state
    ),
  [actionTypes.TECH_USER_CHANGE_PWD_VERIFY_CA_MOBILE_OTP_SUCCESS]: (
    state: any
  ) =>
    immutableSet(
      [STEP_THREE, STEP_THREE_CALL_STATE],
      IResponseState.SUCCESS,
      state
    ),
  [actionTypes.TECH_USER_CHANGE_PWD_VERIFY_CA_MOBILE_OTP_FAILURE]: (
    state: any
  ) =>
    immutableSet(
      [STEP_THREE, STEP_THREE_CALL_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.TECH_USER_CHANGE_PWD_VERIFY_SEC_QUESTS]: (state: any) =>
    immutableSet(
      [STEP_THREE, STEP_THREE_CALL_STATE],
      IResponseState.PENDING,
      state
    ),
  [actionTypes.TECH_USER_CHANGE_PWD_VERIFY_SEC_QUESTS_SUCCESS]: (state: any) =>
    immutableSet(
      [STEP_THREE, STEP_THREE_CALL_STATE],
      IResponseState.SUCCESS,
      state
    ),
  [actionTypes.TECH_USER_CHANGE_PWD_VERIFY_SEC_QUESTS_FAILURE]: (state: any) =>
    immutableSet(
      [STEP_THREE, STEP_THREE_CALL_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.TECH_USER_CHANGE_PWD_VERIFY_UIGP_OTP]: (state: any) =>
    immutableSet(
      [STEP_THREE, STEP_THREE_CALL_STATE],
      IResponseState.PENDING,
      state
    ),
  [actionTypes.TECH_USER_CHANGE_PWD_VERIFY_UIGP_OTP_SUCCESS]: (state: any) =>
    immutableSet(
      [STEP_THREE, STEP_THREE_CALL_STATE],
      IResponseState.SUCCESS,
      state
    ),
  [actionTypes.TECH_USER_CHANGE_PWD_VERIFY_UIGP_OTP_FAILURE]: (state: any) =>
    immutableSet(
      [STEP_THREE, STEP_THREE_CALL_STATE],
      IResponseState.ERROR,
      state
    ),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
